import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';
import type { DashboardSummary } from '@/api/types';
import { useProjectContext } from '@/project/ProjectContext';

export function useDashboardSummary() {
  const { selectedProjectId } = useProjectContext();
  const projectId = selectedProjectId ?? 'all';

  return useQuery({
    queryKey: ['dashboard', projectId],
    queryFn: () =>
      apiFetch<DashboardSummary>(
        `/api/dashboard/summary?projectId=${encodeURIComponent(projectId)}`,
      ),
  });
}
